const initialState = {id:"", name:"", email:"", phone:"", role:"", clockInTime:"", clockOutTime:"", clockIn: false, passcode:"" } ;

function selectedUser(state = initialState, action){
    switch(action.type){
        
        case 'ADD_SELECT_USER' : 
            
            state = action.data;
            
            return state;
       


        case 'REMOVE_SELECT_USER' : 
            
            state = {id:"", name:"", email:"", phone:"", role:"", clockInTime:"", clockOutTime:"", clockIn: false, passcode:"" };
        
            return state;
   
    default : return state;


    }

}

export default selectedUser;